import React from 'react';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import RecommendProductList from '../RecommendProductList';
import RecommendProductListSearchBox from '../RecommendProductListSearchBox';

const RecommendProductListWrap = (props) => {
  const { recommendProductList, setData, getList } = props;

  return (
    <div className="recommend-search-word-list-wrap">
      {/* 추천 상품 검색 박스*/}
      <RecommendProductListSearchBox
        setData={(data) =>
          setData({
            path: ['recommendProductList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={recommendProductList.searchData}
        getList={getList}
      />

      {/* 추천 상품 리스트*/}
      <RecommendProductList
        recommendProductList={recommendProductList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={recommendProductList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default RecommendProductListWrap;
